<!--我的资料-->
<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_company">
          <Row>
            <Col span="24">
              <div class="tab" v-if="isCompany">
                <table cellspacing="0" cellpadding="0" class="firstTable">
                  <tr style="font-weight:bold">
                    <td colspan="6" style="font-size:18px;background:#dddee1">工商信息</td>
                  </tr>
                  <tr>
                    <td>统一信用代码</td>
                    <td>{{table.creditCode}}</td>
                    <td>经营状态</td>
                    <td>{{table.regStatus}}</td>
                    <td>所属行业</td>
                    <td>{{table.industry }}</td>
                  </tr>
                  <tr>
                    <td>法定代表人</td>
                    <td>{{table.legalPersonName}}</td>
                    <td>公司名称</td>
                    <td>{{table.company}}</td>
                    <td>实际经营地</td>
                    <td>{{table.realInstitute}}</td>
                  </tr>
                  <tr>
                    <td>成立时间</td>
                    <td>{{table.estiblishTime|formatWithhour}}</td>
                    <td>发照日期</td>
                    <td>{{table.fromTime |formatWithhour}}</td>
                    <td>营业期限</td>
                    <td>{{table.toTime|formatWithhour}}</td>
                  </tr>
                  <tr>
                    <td>注册资金</td>
                    <td>{{table.regCapitalCurrency }}</td>
                    <td>登记机关</td>
                    <td>{{table.regLocation}}</td>
                    <td>企业地址</td>
                    <td>{{table.address}}</td>
                  </tr>
                  <tr>
                    <td>联系人姓名</td>
                    <td>{{table.linkManName}}</td>
                    <td>联系电话</td>
                    <td>{{table.linkManPhone}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </Col>
          </Row>
          <Form ref="ruleCustom" :model="formCustom" :rules="ruleCustom" :label-width="0">
            <table  cellspacing="0" cellpadding="0" class="firstTable">
              <tr>
                <td colspan="2" style="font-size:18px;background:#dddee1" v-if="isCompany">公司信息</td>
                <td colspan="2" style="font-size:18px;background:#dddee1" v-if="!isCompany">个人信息</td>
              </tr>
              <tr v-if="isCompany">
                <td>公司名称</td>
                <td>
                  {{formCustom.company}}
                </td>
              </tr>
              <tr v-if="isCompany">
                <td>公司法人</td>
                <td>
                  {{formCustom.legalPersonName}}
                </td>
              </tr>
              <tr v-if="isCompany">
                <td>实际经营地</td>
                <td>
                  <Input v-model="formCustom.realInstitute" v-if="show"></Input>
                  <span v-else>{{formCustom.realInstitute}}</span>
                </td>
              </tr>
              <tr v-if="!isCompany">
                <td>姓名</td>
                <td>
                  {{formCustom.name}}
                </td>
              </tr>
              <tr v-if="isCompany">
                <td>联系人</td>
                <td>
                  <Input v-model="formCustom.linkName" v-if="show"/>
                  <span v-else>{{formCustom.linkName}}</span>
                </td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td>
                  <Input v-model="formCustom.linkPhone" v-if="show" :maxlength="11"></Input>
                  <span v-else>{{formCustom.linkPhone}}</span>
                </td>
              </tr>
              <tr v-if="isCompany">
                <td>地址</td>
                <td>
                  <Input v-model="formCustom.address" v-if="show"/>
                  <span v-else>{{formCustom.address}}</span>
                </td>
              </tr>
            </table>
          </Form>
          <Row>
            <Col span="4" offset="8">
              <my-button @confirm="save" v-if="show">保存</my-button>
              <my-button @confirm="edit" v-if="!show">修改</my-button>
            </Col>
            <Col span="4">
              <my-button @confirm="cancel" v-if="show">取消</my-button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
  import tableEdit from '@/components/tableEdit'
  export default {
    name: "profile",
    components: {
      MyButton,
      tableEdit,
    },
    data() {
      const validateLinkName=(rule,value,callback)=>{
        if(value ===''){
          callback(new Error('联系人不能为空'))
        }else{
          callback();
        }
      };
      const validateLinkPhone=(rule,value,callback)=>{
        if(value===''){
          callback(new Error('联系电话不能为空'))
        }else{
          callback();
        }
      }
      const validateAddress = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('地址不能为空'));
        } else {
          callback();
        }
      };
      const validateName = (rule,value,callback)=>{
        if(value ===''){
          callback(new Error('客户姓名不能为空'))
        }else{
          callback();
        }
      };
      const validateRealInstitute =(rule,value,callback)=>{
        if(value===''){
          callback(new Error ('实际经营地不能为空'))
        }else{
          callback();
        }
      };
      const validateLegalPersonName=(rule,value,callback)=>{
        if(value===''){
          callback(new Error('公司法人不能为空'))
        }else{
          callback();
        }
      };
      return {
        formCustom: {},
        table:{},
        currentUser:{},
        isCompany:false,
        show: false,
        editable: false,
        firstIdentification: false,
        nofirstIdentification: false,
        ruleCustom: {
          linkName:[
            {validator:validateLinkName,trigger:'blur'}
          ],
          linkPhone:[
            {validator:validateLinkPhone,trigger:'blur'}
          ],
          address: [
            {validator: validateAddress, trigger: 'blur'}
          ],
          name:[
            {validator:validateName,trigger:'blur'}
          ],
          realInstitute:[
            {validator:validateRealInstitute,trigger:'blur'}
          ],
          legalPersonName:[
            {validator:validateLegalPersonName,trigger:'blur'}
          ],
        },
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      edit() {
        this.show = true;
        this.editable = true;
      },
      save() {
        this.show = false;
        this.editable = false;
        this.formCustom.id=this.formCustom.detailId;
        ApiClient.put('/desktop/profile/update.do', this.formCustom).then(data => {
          ApiClient.get('/desktop/profile/detail.do').then(data => {
            this.formCustom = data;
          })
        })
      },
      cancel() {
        this.show = false;
        ApiClient.get('/desktop/profile/detail.do').then(data => {
          this.formCustom = data;
        })
      },
      confirm() {
        ApiClient.get('/desktop/profile/checkFail.do', {id: this.formCustom.detailIdNew}).then(data => {
          ApiClient.get('/desktop/profile/detail.do').then(data => {
            this.formCustom = data;
          })
        })
      },
      fetchData(){
        ApiClient.get('/desktop/profile/detail.do').then(data => {
          this.formCustom = data;
          if(this.formCustom.detailId == null && this.formCustom.stateNew == null){
            this.formCustom.state  = '未审核'
            this.$router.push({name:'userInfo'})
          }
          if(this.formCustom.stateNew == '处理中'){
            this.formCustom.state  = '审核中'
            this.$router.push({name:'checkPending'})
          }
          if(this.formCustom.state == '成功'){
            this.formCustom.state  = '已审核'
            this.$router.push({name:'profile'})
          }
          if(this.formCustom.stateNew == '失败'){
            ApiClient.get('/desktop/profile/checkFail.do',{
              id:this.formCustom.detailIdNew
            }).then(data=>{
              this.$router.push({name:'checkFailed'})
            })
          }
          ApiClient.get('/desktop/customer/businessCustomerDetail.do',{company:this.formCustom.company}).then(data => {
            if(data.reason='ok'){
              this.table=data;
            }
          });
        })
        this.currentUser = JSON.parse(window.sessionStorage.getItem('currentUser'));
        this.isCompany = (this.currentUser.accountType=='company');
      }
    }
  }
</script>
<style scoped lang="less">
  /*表格*/
  .firstTable{
    border-collapse: collapse;
    width:100%;
    margin:0 auto;
    margin-top:15px;
  }
  .firstTable td {
    border: 1px solid #ccc;
    padding: 10px 18px;
    color: #525252;
    font-size: 15px;
  }
</style>
<style scoped lang="less">
  .container_wang_company button {
    margin-left: 46%;
    margin-top: 60px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/myProfile/profile.vue